export default "/wp-content/themes/onnit/script/cart/dist/onnitIn30Bg-3d6b68fe.jpg";